export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-fire-fill"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-900">火影同人动漫</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              全网最全火影同人动漫合集，热血剧情、穿越重生、系统战斗，点开即看，追更不迷路。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-wechat-fill", "ri-qq-fill", "ri-weibo-fill", "ri-bilibili-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#home"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 快捷导航 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "热门推荐", href: "#hot" },
                { label: "题材分类", href: "#categories" },
                { label: "最新追更", href: "#latest" },
                { label: "品牌口碑", href: "#reputation" },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 题材分类 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">题材分类</h4>
            <ul className="mt-4 space-y-2.5">
              {["剧情同人", "穿越同人", "系统同人", "重生同人", "战斗同人"].map((item) => (
                <li key={item}>
                  <a
                    href="#categories"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 支持 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">支持中心</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href="#faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  联系我们
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  创作者投稿
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 火影同人动漫 · 保留所有权利
          </p>
          <p className="text-xs text-foreground-500">
            本站为粉丝同人内容聚合站，一切作品版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}